<div class="site-page-header-ghost-wrapper">
    <nz-page-header class="site-page-header" nzTitle="Laboratórios" nzSubtitle=" - Lista dos laboratórios cadastrados.">
        <nz-page-header-extra>
            <button nz-button nzType="primary" routerLink="lancamento"><i nz-icon nzType="plus"></i> Novo
                    Cadastro</button>
        </nz-page-header-extra>
    </nz-page-header>

    <div nz-row>

        <div nz-col nzSpan="24">
            <nz-divider></nz-divider>
        </div>
        <div nz-col nzSpan="19" style="margin-bottom:10px;">
            <nz-input-group nzCompact nzSearch [nzAddOnAfter]="suffixIconButton">
                <input type="text" [(ngModel)]="search" style="min-width: 500px!important;" nz-input placeholder="Pesquise pelo nome do laboratório" />

            </nz-input-group>
            <ng-template #suffixIconButton>
                <button nz-button nzType="primary" (click)="searchLaboratorio()" nzSearch><i nz-icon nzType="search"></i></button>
            </ng-template>
        </div>
        <div nz-col nzSpan="4" style="margin-left: 10px;">
            <button nz-button nzType="danger" *ngIf="!isVisibleCancelFiltro" disabled (click)="removerFiltro()"><i nz-icon nzType="close-circle" nzTheme="outline"></i> Cancelar Pesquisa</button>
            <button nz-button nzType="danger" *ngIf="isVisibleCancelFiltro" (click)="removerFiltro()"><i nz-icon nzType="close-circle" nzTheme="outline"></i> Cancelar Pesquisa</button>
        </div>

        <div nz-col nzSpan="24">
            <nz-table #basicTable (nzQueryParams)="onQueryParamsChange($event)" nzSize="small" [(nzData)]="laboratorios" [nzFrontPagination]="false" [nzLoading]="loading" [nzTotal]="total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Descrição</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-template ngFor let-data [(ngForOf)]="basicTable.data">
                        <tr>
                            <td style="color:#bdc3c7;" *ngIf="data.ativo === 0">{{data.idlaboratorio}}</td>
                            <td *ngIf="data.ativo === 1">{{data.idlaboratorio}}</td>

                            <td style="color:#bdc3c7;" *ngIf="data.ativo === 0">{{data.descricao}}</td>
                            <td *ngIf="data.ativo === 1">{{data.descricao}}</td>

                            <td>
                                <button nz-button nz-dropdown [nzDropdownMenu]="menu">Operações<i nz-icon
                                            nzType="down"></i></button>
                                <nz-dropdown-menu #menu="nzDropdownMenu">
                                    <ul nz-menu>
                                        <li nz-menu-item *ngIf="data.ativo === 1">
                                            <a routerLink="lancamento/{{data.idlaboratorio}}">Editar</a>
                                        </li>
                                        <li nz-menu-item>
                                            <a style="color:#f63849;" *ngIf="data.ativo === 1" (click)="inativar(data.idlaboratorio)">Inativar</a>
                                            <a style="color:#27ae60;" *ngIf="data.ativo === 0" (click)="ativar(data.idlaboratorio)">Ativar</a>
                                        </li>
                                    </ul>
                                </nz-dropdown-menu>
                            </td>
                        </tr>

                    </ng-template>
                </tbody>
            </nz-table>
        </div>
    </div>
</div>